export default __webpack_public_path__ + "static/media/dessert.58604c11.png";